import React from "react";
import "./styles.scss";
import {connect} from "react-redux";
import {dialogVisible} from "./actions";

const WORDS = {
    cn: {seven: 440, mini: 440},
    cz: {seven: 900, marathon: 5000, mini: 1000, basic: '>2000'},
    dk: {seven: 650, mini: 1000, basic: '>2000'},
    nl: {seven: 500, marathon: 1600, mini: 800, basic: '>2000'},
    en: {seven: 1000, marathon: 1300, mini: 1800, basic: '>2500'},
    fr: {seven: 600, marathon: 1500, mini: 1600, basic: '>2500'},
    de: {seven: 2000, marathon: 2000, mini: 2500, basic: '>3000'},
    gr: {seven: 1300, mini: 1500},
    it: {seven: 500, marathon: 1700, mini: 1700, basic: '>2500'},
    no: {seven: 600, marathon: 2000, mini: 700, basic: '>2000'},
    pl: {seven: 900, marathon: 3300, mini: 1000, basic: '>2000'},
    pt: {seven: 350, marathon: 1000, mini: 500, basic: '>2000'},
    sk: {seven: 800, mini: 1000},
    es: {seven: 400, marathon: 1500, mini: 1500, basic: '>2500'},
    se: {seven: 700, mini: 900, basic: '>1500'},
    tr: {seven: 500, marathon: 1500, mini: 600}
};

class Component extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAdditional: false
        };

        this.languageCode = props.languageCode;
        this.headers = [
            {title: 'Языковой марафон', colorClass: '', url: props.marathonUrl},
            {title: 'Базовый курс', colorClass: 'bg-primary', url: props.basicUrl},
            {title: 'Мини курс', colorClass: 'mini', url: props.miniUrl},
            {title: '7 уроков', colorClass: 'free', url: props.sevenUrl}
        ];

        this.details = [
            {
                title: 'Цена',
                items: [
                    props.marathonPrice,
                    props.hasGroupCourse ? props.baseGroupPrice + ' в месяц' : props.basePrice,
                    props.miniPrice,
                    'бесплатно'
                ]
            }
        ];

        if (props.exampleSeven || props.exampleBasic) {
            this.details.push(
                {
                    title: 'Как вы сможете говорить после курса',
                    items: [
                        false,
                        props.exampleBasic ?
                            <button className="btn btn-sm btn-warning"
                                    onClick={() => this.props.openDialog(props.exampleBasic)}>показать</button>
                            : false,
                        props.exampleSeven ?
                            <button className="btn btn-sm btn-success"
                                    onClick={() => this.props.openDialog(props.exampleSeven)}>показать</button>
                            : false,
                        false
                    ]
                }
            );
        }

        this.details = this.details.concat([
            {title: 'Возможность оплаты частями', items: [false, true, false, false]},
            {title: 'Требуемый начальный уровень', items: ['с нуля', 'с нуля', 'с нуля', 'с нуля']},
            {
                title: 'Уровень на выходе',
                items: ['Beginner, A1-A2', 'Intermediate (A2-B1)', 'Beginner, A1', 'Beginner, A1']
            }
        ]);

        if (this.languageCode != 'fi' && this.languageCode != 'jp') {
            this.details.push({
                title: 'Словарный запас',
                items: [
                    this.getWordsCount('marathon'),
                    this.getWordsCount('basic'),
                    this.getWordsCount('mini'),
                    this.getWordsCount('seven')
                ]
            });
        }
        if (this.languageCode != 'cn' && this.languageCode != 'jp') {
            this.hours = 40
            this.count_lessons = 10
        }
        else {
            this.hours = 48
            this.count_lessons = 12
        }

        this.details = this.details.concat([
            {title: 'Пожизненный доступ к материалам', items: [true, true, true, true]},
            {title: 'Инвестиции времени', items: ['60 часов', '400 часов', this.hours + ' часов', '20 часов']},
            {title: 'Длительность занятия с преподавателем', items: [false, '60 минут', '60 минут', false]},
            {title: 'Четкая система обучения', items: [true, true, true, true]},
            {title: 'Длительность курса', items: ['30 дней', '4 месяца',
                                                    this.count_lessons + ' занятий', 'неограничена']},
            {title: 'Сроки завершения курса', items: ['36 дней', '24 недели', '6 недель', 'неограничена']}
        ]);

        if (props.hasIntermediate) {
            this.details.push({
                title: 'Продолжение обучения на уровнях B1, B2 и выше',
                items: [false, true, false, false]
            });
        }

        this.details = this.details.concat([
            {title: 'Скидка на дальнейшее обучение', items: [false, true, true, false]},
            {title: 'Гарантия результата', items: [true, true, true, false]},
            {title: 'Сертификат об окончании курса', items: [true, true, false, false]},
            {title: 'Использование ИИ (искусственного интеллекта)', items: [false, true, true, false]}
        ]);

        this.additionalDetails = [
            {title: 'Гибкость расписания', items: [true, true, true, true]},
            {title: 'Техподдержка', items: [true, true, true, true]}
        ];

        if (props.marathon) {
            this.additionalDetails.push({title: 'Видео', items: [true, true, true, true]});
        }

        this.additionalDetails = this.additionalDetails.concat([
            {title: 'Аудио', items: [true, true, true, true]},
            {title: 'Упражнения', items: [true, true, true, true]},
            {title: 'Озвучка упражнений', items: [true, true, true, true]},
            {title: 'Личный кабинет на сайте', items: [true, true, true, true]},
            {title: 'Возможность скачивания материалов', items: [true, true, true, true]},
            {title: 'Трекинг прогресса', items: [true, true, true, false]},
            {title: 'Регулярность занятий', items: [true, true, true, false]},
            {title: 'Возможность переноса занятий', items: [true, true, true, false]},
            {title: 'Предоставление счета на оплату (также на юрлицо)', items: [true, true, true, false]},
            {title: 'Домашние задания', items: [true, true, true, false]},
            {title: 'Проверка домашних заданий преподавателем', items: [false, true, true, false]},
            {title: 'Уведомления по электронной почте', items: [false, true, true, false]},
        ]);

        if (props.marathon) {
            this.additionalDetails.push(
                {title: 'Разговоры с носителями языка (не преподавателями)', items: [true, false, false, false]}
            );
        }

        if (props.hasNativeSpeaker) {
            this.additionalDetails.push({
                title: 'Занятия с преподавателем - носителем языка',
                items: [false, true, false, false]
            });
        }

        this.additionalDetails = this.additionalDetails.concat([
            {title: 'Занятия с русскоговорящим преподавателем', items: [false, true, true, false]},
            {title: 'Индивидуальный подход', items: [false, true, true, false]},
            {title: 'Персональный менеджер', items: [false, true, true, false]},
            {title: 'Возможность смены преподавателя', items: [false, true, true, false]},
            {title: 'MP3 записи занятий', items: [false, true, true, false]},
            {title: 'Дополнительные темы на выбор', items: [false, true, true, false]}
        ]);

        if (props.hasMp3) {
            this.additionalDetails.push({title: 'Грамматика в MP3', items: [false, true, false, false]});
        }

        if (props.hasDicts) {
            this.additionalDetails.push({title: 'MP3 словари', items: [false, true, false, false]});
        }

        this.additionalDetails = this.additionalDetails.concat([
            {title: 'Разработка персональных тем (за доп. оплату)', items: [false, true, false, false]},
            {title: 'Подбор персональной программы (при необходимости)', items: [false, true, false, false]},
            {title: 'Возможность заниматься в семейной мини-группе', items: [false, true, false, false]},
            {title: 'Мобильное приложение (iOS, Android)', items: [false, false, true, true]}
        ]);

        if (!props.marathon) {
            this.headers.splice(0, 1);
            this.details.forEach(this.removeMarathonItems);
            this.additionalDetails.forEach(this.removeMarathonItems);

            if (!props.basePrice) {
                this.headers.splice(0, 1);
                this.details.forEach(this.removeMarathonItems);
                this.additionalDetails.forEach(this.removeMarathonItems);
            }
        } else if (!props.basePrice) {
            this.headers.splice(1, 1);
            this.details.forEach(item => item.items.splice(1, 1));

            this.additionalDetails.forEach(item => item.items.splice(1, 1));
        }
    }

    removeMarathonItems(item) {
        item.items.splice(0, 1);
    }

    getWordsCount(course) {
        return WORDS[this.languageCode][course] ? WORDS[this.languageCode][course] + ' слов' : false;
    }

    formatItem(item) {
        if (item === true) {
            return <i className="fa fa-fw fa-check"/>
        } else if (item === false) {
            return <i className="fa fa-fw fa-minus"/>
        }
        return item;
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Only re-render if showAdditional state changes
        // Props should never change after initial mount for this component
        return this.state.showAdditional !== nextState.showAdditional;
    }

    render() {
        // Create headers once - React will handle re-rendering efficiently with stable keys
        const headers = [
            <th key="header-empty"/>
        ];
        this.headers.forEach((header, i) => {
            headers.push(
                <th key={`header-${i}`} className={header.colorClass}>{header.title}</th>
            );
        });

        const rows = [];
        this.details.forEach((row, i) => {
            rows.push(
                <tr key={i}>
                    <th>{row.title}</th>
                    {row.items.map((item, j) => <td key={j}
                                                    className={this.headers[j].colorClass}>{this.formatItem(item)}</td>)}
                </tr>
            )
        });

        const additionalRows = [];
        this.additionalDetails.forEach((row, i) => {
            additionalRows.push(
                <tr key={i}>
                    <th>{row.title}</th>
                    {row.items.map((item, j) => <td key={j}
                                                    className={this.headers[j].colorClass}>{this.formatItem(item)}</td>)}
                </tr>
            )
        });

        return (
            <div>
                <div className="table-responsive table-striped table-course-details">
                    <table className="table">
                        <thead>
                        <tr>{headers}</tr>
                        </thead>

                        <tbody>
                        {rows}
                        {this.state.showAdditional ? additionalRows : null}
                        <tr>
                            <td/>
                            {this.headers.map((item, i) => <td key={i} className={this.headers[i].colorClass}>
                                <a href={item.url}
                                   className={`btn ${this.getBtnClass(i)}`}>открыть</a>
                            </td>)}
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="text-center">
                    {this.state.showAdditional ? null :
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.setState({showAdditional: true})
                        }}
                           className="btn btn-info">еще подробнее</a>
                    }
                </div>
            </div>
        )
    }

    getBtnClass(i) {
        return this.headers[i].colorClass == 'bg-primary' ? 'btn-warning' : 'btn-success';
    }
}

const Widget = connect(
    null,
    dispatch => ({
        openDialog: url => dispatch(dialogVisible(true, url))
    })
)(Component);

export default Widget;



// WEBPACK FOOTER //
// ./src/course_details/component.js